import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

import { PaginationInstance } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { CourseService } from 'src/app/services/course/course.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { ManagerService } from 'src/app/services/manager/manager.service';
import { Filter } from '../../filter/filter.model';
import { Sort } from '@angular/material/sort';
import { DepartmentService } from 'src/app/services/department/department.service';
import { MoreCourseInfoComponent } from '../../courses/more-course-info/more-course-info.component';
import { ViewExamsheetComponent } from '../../courses/view-examsheet/view-examsheet.component';

@Component({
  selector: 'app-view-assigned-employee',
  templateUrl: './view-assigned-employee.component.html',
  styleUrls: ['./view-assigned-employee.component.scss']
})
export class ViewAssignedEmployeeComponent {
  public isFilterShow: boolean = false;
  public filterObj: Filter = {
    operand: "or",
    arr: []
  }
  public filterArr: any[] = [
    { key_name: "First Name", key_val: "employee_first_name", type: 'text' },
    { key_name: "Last Name", key_val: "employee_last_name", type: 'text' },
    { key_name: "Email", key_val: "employee_email", type: 'text' },
    { key_name: "Department", key_val: "department_name", type: 'select' },
    { key_name: "Training Date", key_val: "deadline_date", type: 'date' },
    { key_name: "Deadline Date", key_val: "training_date", type: 'date' },
  ]
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public maxPaginationSize = GlobalService.maxPaginationSize
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public imageURL: any = GlobalService.imageURL;
  public displayedColumns: string[] = ['user_info', 'type'];
  public displayedColumnsEmp: string[] = ['user_info', 'course_info', 'training_date', 'deadline_date', 'course_type', 'start_course', 'course_progres', 'action'];
  public dataSource = new MatTableDataSource();
  public count!: any;
  public empData;
  public courseStatistics: any;
  public isSpinnerLoading: boolean = false;
  private animationConfig: {} = { enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", }
  public viewType!: string;
  public searchInput:string='';
  constructor(private _liveAnnouncer: LiveAnnouncer, private managerService: ManagerService, private appService: AppService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any, public dialogRef: MatDialogRef<ViewAssignedEmployeeComponent>,
    private courseService: CourseService, private spinner: NgxSpinnerService, private depService: DepartmentService,
    private dialog: MatDialog, private commonService: CommonService) { }
  ngOnInit() {
    if (this.dialogData) {
     this.checkDataType()
    }
  }
  checkDataType(){
    if (this.dialogData.type == 'view_department_assigned') {
      this.viewType = 'department_assigned'
      this.getAssignedDepartmentList()
    }
    else if (this.dialogData.type == 'view_employee') {
      this.viewType = "employee"
      this.getEmployeeList()
    }
  }
  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement
    this.config.itemsPerPage = Number(tar.value)
    this.config.currentPage = 1
    this.checkDataType()
    // this.onViewCourse(this.courseId, 'company', this.packageId)
  }
  onFilterView() {
    this.isFilterShow = !this.isFilterShow;
  }
  onPageChange(number: number) {
    this.config.currentPage = number;
    this.checkDataType()
    // this.onViewCourse(this.courseId, 'company', this.packageId)
  }
  callApi(obj) {
    this.filterObj = obj
    // this.onViewCourse(this.courseId, 'company', this.packageId)
  }
  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  getAssignedDepartmentList() {
    this.spinner.show()
    let data = {
      cd_i: this.dialogData.id,
      sh: this.searchInput.trim(),
      st: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      r_p: this.config.itemsPerPage,
      f_a: this.filterObj.arr,
      op_nd: this.filterObj.operand
    }
    this.depService.assignedList(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        if (success.status == 200) {
          this.count = success.data.count;
          this.dataSource = new MatTableDataSource(success.data.assign_list);
        }
      },
      error: (error: any) => {
        this.spinner.hide()
        this.commonService.handleError(error)
      }
    });
  }
  getEmployeeList() {
    this.spinner.show()
    let data = {
      ma_i: this.dialogData.id,
      sh: this.searchInput.trim(),
      st: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      r_p: this.config.itemsPerPage,
      f_a: this.filterObj.arr,
      op_nd: this.filterObj.operand
    }
    this.managerService.viewEmployeeList(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        if (success.status == 200) {
          this.dataSource = new MatTableDataSource(success.data.employee_list);
          this.count=success.data.count
        }
      },
      error: (error: any) => {
        this.spinner.hide()
        this.commonService.handleError(error)
      }
    });
  }
  onCertificateDownload(element: any) {
    this.appService.downloadFile(element.c_img, 'certificate.png')
  }
  onViewExamSheet(element: any) {
    const dialogRef = this.dialog.open(ViewExamsheetComponent,
      Object.assign({ data: { data: element } }, this.animationConfig, { width: '50%', minWidth: '300px', maxWidth: "600px", }));
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }
  onMoreInfo(element) {
    const dialogRef = this.dialog.open(MoreCourseInfoComponent,
      Object.assign({ data: { data: element } }, this.animationConfig, { width: '55%', minWidth: '300px', maxWidth: "800px",height:'98%',maxHeight:'600px' }));
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }
  convertToLowerCase(text:String){
    return text.toLowerCase()
  }
}
